import React, { useRef, useContext } from 'react';
import cn from 'classnames';
import ReactDOM from 'react-dom';
import makeStyles from '@mui/styles/makeStyles';
import { CloseIcon } from 'components/elements/Icons';
import { useClickOutside } from 'hooks';
import ModalContext from 'contexts/modalContext';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function Modal() {
  const modalElRef = useRef(document.getElementById('modal'));
  const { modalContent, handleModal, showModal, options } = useContext(ModalContext);
  const styles = useStyles();
  const modalRef = useRef(null);

  useClickOutside(modalRef, () => (options.removeOutsideClick ? {} : handleModal(false)));

  const modalStyles = cn(styles.modal, { [styles.smallSizeModal]: options.size === 'small' });

  return modalElRef.current
    ? ReactDOM.createPortal(
        showModal ? (
          <>
            <div className={styles.overlay} />
            <div className={modalStyles} ref={modalRef}>
              <button className={styles.closeButton} type="button" onClick={() => handleModal(false)}>
                <CloseIcon />
              </button>
              {modalContent}
            </div>
          </>
        ) : null,
        modalElRef.current,
      )
    : null;
}

export default Modal;
